export default __webpack_public_path__ + "static/media/cameraIcon.331e58d6.png";